<template>
    <jet-select
        :disabled="disabled"
        :horizontal="false"
        :is-processing="isProcessing"
        :model-value="modelValue"
        :options="usageCategories"
        :resettable="false"
        class="asset-usage-category"
        name="usageCategory"
        @update:model-value="$emit('update:modelValue', $event)"
    >
    </jet-select>
</template>
<script setup>
import JetSelect from '@/Jetstream/Select.vue';

defineEmits(['update:modelValue']);
defineProps({
    disabled: { type: Boolean, default: false },
    modelValue: { type: String },
    usageCategories: { type: Array, default: () => [] },
    isProcessing: { type: Boolean, default: false },
});
</script>
